import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export const appLevelQueryClient = new QueryClient();

/**
 * 앱 수준 쿼리 클라이언트.
 *
 * 앱 수준에서 쿼리 캐시를 합니다.
 *
 * @see https://tanstack.com/query/latest/docs/framework/react/guides/migrating-to-react-query-4#custom-contexts-for-multiple-providers
 */
export const AppLevelQueryClientProvider = ({ children }: { children: React.ReactNode }) => {
  return <QueryClientProvider client={appLevelQueryClient}>{children}</QueryClientProvider>;
};
